import { wOrgIdMiddleware } from "../utils/commonUtils";
import { OK } from "../utils/constant";
import http from "./http";

const EmrConfigService = {
  getEmrConfigList: async (screen_type = "",query={}) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`/emr-setup/${screen_type}/?${queryString}`);
      return response; // <- return only the array inside `data`
    } catch (error) {
      return [];
    }
  },
  getEmrFormById: async (screen_type = "", formId = "") => {
    try {
      const response = await http.GET(`/emr-setup/${screen_type}/${formId}`);
      return response; // You can also return response.data if needed
    } catch (error) {
      return null; // or handle/log error as needed
    }
  },

  getEmrFiledTypes: async () => {
    try {
      const response = await http.GET(`/emr/field-types/`);
      return response; // <- return only the array inside `data`
    } catch (error) {
      return [];
    }
  },
  saveEmrConfig: async (screenType, data) => {
    try {
      const response = await http.POST(`/emr-setup/${screenType}/`, data);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },
  DeleteEmrChart: async (screenType, formId) => {
    try {
      const response = await http.DELETE(`/emr-setup/${screenType}/${formId}`);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },
  
  updateEmrConfig: async (screenType, id, data)=>{
    try {
      const response = await http.PUT(`/emr-setup/${screenType}/${id}/`, data);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },
  
  getActivityDropdownListForConfig: async (orgId='null',query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
        const response = await http.GET(`/organizations/${orgId}/get-dropdown/activity?${queryString}`);
        if (response.code === OK) {
          return response.data;
      }
        
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  },
  updateConfigPosition:async(screen_type,mappingList)=>{
    try {      
     const response= await http.PUT(`/emr/form/position/${screen_type}`,mappingList);
     if(response=== OK){
      console.log(" successss");
     }
     else{
      console.log(" reponse ===" , response);
      
     }
    } catch (error) {
      
    }
  },
   visifetchProgressData:async(id, screen_type)=>{    
    
    try {      
     const response= await http.GET(`/emr-chart-view/${id}/emr-process-note/${screen_type}`);     
    //  console.log(" resp" , response.data);
     
     if(response.status==="SUCCESS"){
      return response
     }
     else{
      console.log(" reponse ===" , response);
      
     }
    } catch (error) {
      
    }
  },
  upateProcessData:async(form_id,screen_type, payload)=>{    
    
    try {      
     const response= await http.POST(`/emr-chart-view/${form_id}/update-progress-note/${screen_type}`,payload);     
     if(response.status==="SUCCESS"){
      return response
     }
     else{
      console.log(" reponse ===" , response);
      
     }
    } catch (error) {
      
    }
  },
  getICD10DropdownListForConfig:async(body_part)=>{
    try {
            const response = await http.POST(`/icd10/search`,body_part);
            console.log("val",response);
            
            if (response.code === OK) {
              return response;
          }
            
        } catch (error) {
          console.error("error", error);
          throw error;
        }
      },
  getTabsList:wOrgIdMiddleware(async(url,visitid,visit_category)=>{
  try {
        const response = await http.GET(`${url}${visitid}/emr/tablist/${visit_category}`);        
        if (response.code === OK) {
          return response.data;
      }
        
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  }),
  setTabsListstatus:wOrgIdMiddleware(async(url,visitid,payload,VISITCATEGORY)=>{
  try {
        const response = await http.POST(`${url}${visitid}/emr/tablist/${VISITCATEGORY}`,payload);        
        if (response.code === OK) {
          return response;
      }
        
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  }),

};

export default EmrConfigService;
